import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import { AlignmentType } from '../../models/ecd-block-models';
import { ContentSpacer } from '../../../../TCSMApp/global/components/layout/generic-content-spacer';

interface ButtonWrapperProps {
    flexEnd?: boolean,
    alignment?: AlignmentType,
}

const usestyles = makeStyles((theme) => ({
    buttonContainer: {
        '& > a , & > button': {
            marginRight: theme.spacing(.5),
            marginBottom: theme.spacing(.5),
        },
    },
}));


export function ButtonWrapper(props: React.PropsWithChildren<ButtonWrapperProps>){
    const classes = usestyles();

    function ParseJustify(){
        if (props.alignment) {
            switch (props.alignment) {
                case AlignmentType.Left:
                    return 'flex-start';

                case AlignmentType.Center:
                    return 'center';
            
                case AlignmentType.Right:
                default:
                    return 'flex-end';                    
            }
        }

        return props.flexEnd ? 'flex-end' : 'flex-start';
    }

    return (
        <div className='quickfind-button-wrapper'>
            <ContentSpacer>
                <Grid data-testid="button-wrapper" container item xs={12} justifyContent={ParseJustify()} className={classes.buttonContainer} >
                    {props.children}
                </Grid>
            </ContentSpacer>
        </div>
    );
}


ButtonWrapper.defaultProps = {
    flexEnd: null,
    alignment: null,
};